module.exports = "0.31.0";



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/version.js
// module id = 23
// module chunks = 0 1